<template>
  <div class="certification">
    <div class="page_tit_box">
      <div class="center_content u-flex">
        <div>
          <img class="tit_img" src="../assets/images/index_icon1.png" alt="" />
        </div>
        <div>首页>企业认证</div>
      </div>
    </div>

    <div class="cert_center">
      <div class="cert_tit_box u-flex">
        <img src="../assets/images/qyrz.png" alt="" />
        <div class="cert_line"></div>
      </div>
      <div class="u-flex u-row-between cert_b_box">
        <div class="cert_box_l">
          <div class="cert_box">
            <div class="cert_tt">企业信息</div>
            <div class="cert_tt_bg">
              <el-form
                label-width="140px"
                class="pass_form"
                status-icon
                ref="cert"
                :hide-required-asterisk="true"
                label-position="left"
                :model="certForm"
                :rules="certRules"
              >
                <el-form-item label="企业名称" prop="rzCompany">
                  <el-input
                    class="inlineInput"
                    v-model="certForm.rzCompany"
                    :disabled="isDisabled"
                    placeholder="请输入企业名称"
                  ></el-input>
                </el-form-item>

                <el-form-item label="联系人姓名" prop="rzName">
                  <el-input
                    class="inlineInput"
                    v-model="certForm.rzName"
                    :disabled="isDisabled"
                    placeholder="请输入联系人姓名"
                  ></el-input>
                </el-form-item>

                <el-form-item label="联系人手机号" prop="rzPhone">
                  <el-input
                    class="inlineInput"
                    v-model="certForm.rzPhone"
                    :disabled="isDisabled"
                    placeholder="请输入11位数字"
                  ></el-input>
                </el-form-item>

                <el-form-item label="联系人身份证号码" prop="rzCard">
                  <el-input
                    class="inlineInput"
                    v-model="certForm.rzCard"
                    :disabled="isDisabled"
                    placeholder="请输入身份证号码"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>

        <div class="cert_box_r">
          <div class="cert_box">
            <div class="cert_tt">营业执照</div>
            <div class="cert_tt_bg_2">
              <el-upload
                :class="{ upload_btn_box: true, haveImg: ishaveImg }"
                action="/tbbh/front/common/upload"
                list-type="picture-card"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                :limit="1"
                :file-list="fileList"
                :auto-upload="true"
              >
                <div class="upload_btn" v-show="upload_btn_show">
                  <img src="../assets/images/upload_btn.png" alt="" />
                  <div class="upload_txt">上传图片</div>
                  <div class="upload_tip">支持扩展名：.jpg</div>
                </div>
                <div slot="file" slot-scope="{ file }">
                  <img
                    class="el-upload-list__item-thumbnail"
                    :src="file.url"
                    alt=""
                  />
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>

                    <!-- <span
                      v-if="!isDisabled"
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file)"
                    >
                      <i class="el-icon-delete"></i>
                    </span> -->
                  </span>
                </div>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </div>
          </div>
        </div>
      </div>

      <div class="rzxz_box">
        <div class="rzxz_tit">认证须知</div>
        <div class="rzxz_txt">
          1、一个用户只能认证一个企业； <br />
          2、企业信息请仔细核实；错误填写会导致企业认证失败，如有疑问，通过电话：18536662285联系技术员或者客服；
          <br />
          3、认证完成后如需更改企业信息或认证信息，通过电话：18536662285联系技术员或者客服；<br />
        </div>
      </div>

      

      <div class="certbtn_box" v-if="certForm.renzheng=='0' || certForm.renzheng=='-1'">
        <el-button
          class="certbtn"
          type="primary"
          @click="submitForm('cert')"
          >提交认证</el-button
        >
      </div>

      <div class="result_txt" v-if="certForm.renzheng=='1'">
        等待审核，如需更改信息请联系客服
      </div>

      <div class="result_txt" v-if="certForm.renzheng=='-1'">
        审核未通过，请更改信息重新认证
      </div>

      <div class="result_txt" v-if="certForm.renzheng=='2'">
        认证完成，如需更改信息请联系客服
      </div>
      
    </div>
  </div>
</template>

<script>
import { sesStorage } from "@/model/storage.js";
import  config  from '@/model/config.js'
import Qs from "qs";
export default {
  name: "",
  components: {},
  data() {
    var phonerule = (rule, value, callback) => {
      const reg = 11 && /^((13|14|15|17|18|19)[0-9]{1}\d{8})$/;
      if (value === "") {
        callback(new Error("请输入注册的手机号码"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    return {
      baseurl:config.URL,
      upload_btn_show:true,
      dialogImageUrl: "",
      dialogVisible: false,
      ishaveImg: false,
      isDisabled: false,
      fileList:[],
      certForm: {
        rzCompany: "",
        rzName: "",
        rzPhone: "",
        rzCard: "",
        rzYyzzurl: "",
        token: sesStorage.get('userObj').token
      },
      certRules: {
        rzCompany: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
        rzName: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" },
        ],
        rzPhone: [{ required: true, validator: phonerule, trigger: "blur" }],
        rzCard: [
          { required: true, message: "请输入身份证号码", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    getUser(){
        let param={
           token: sesStorage.get('userObj').token,
        }
        this.$http
          .post("/front/user/getUser", Qs.stringify(param))
          .then((res) => {
            if (res.data.code == 0) {
              this.certForm=res.data.data
              // 营业执照赋值
              if(this.certForm.renzheng=="1" || this.certForm.renzheng=="2"){
                this.fileList.push(
                  {name: this.certForm.rzYyzzurl.substring(this.certForm.rzYyzzurl.lastIndexOf('/') + 1), url: this.baseurl + this.certForm.rzYyzzurl}
                )
                this.ishaveImg = true;
                this.isDisabled=true
              }
              
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
                center: true,
              });
              if(res.data.code == 201){
                setTimeout(()=>{
                  this.$router.push({path:'/home/login'})
                },1000)
              }
            }
          })
      },
    handleRemove(file) {
      console.log(file);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleAvatarSuccess(res, file) {
      if(res.code == 0){
        this.$message({
            message: res.msg,
            type: "success",
            center: true,
          });
        this.certForm.rzYyzzurl = res.data.fileName;
      }else{
        this.$message({
            message: res.msg,
            type: "error",
            center: true,
          });
      }
    },
    beforeAvatarUpload(file) {
      let isJPG;
      if(file.type === "image/jpeg"){
        isJPG=true
      }else if(file.type === "image/png"){
        isJPG=true
      }else{
        isJPG=false
      }

      if (!isJPG) {
        this.$message.error("上传营业执照只能是 JPG 格式 或者 PNG 格式!");
        return false
      }
      this.ishaveImg = true;

      return isJPG;
    },
    
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.certForm.rzYyzzurl) {
            this.$message({
              message: "请上传营业执照",
              type: "warning",
              center: true,
            });
            return;
          }
          this.$http
            .post("/front/user/renzheng", Qs.stringify(this.certForm))
            .then((res) => {
              if (res.data.code == 0) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                  center: true,
                });
                this.isDisabled=true
                setTimeout(()=>{
                  this.$router.push({path:'/home/index'})
                },1000)
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                  center: true,
                });
                if(res.data.code == 201){
                  setTimeout(()=>{
                    this.$router.push({path:'/home/login'})
                  },1000)
                }
              }
            });
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
    this.getUser()
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.certification {
  .page_tit_box {
    background: #e2e4ee;
    padding: 20px 0;
    font-size: 14px;
  }
  .center_content {
    width: 1500px;
    margin: 0 auto;
    .tit_img {
      width: 14px;
      height: 18px;
      margin-right: 16px;
    }
  }
  .cert_center {
    width: 1500px;
    background-color: #fff;
    margin: 20px auto;
    padding: 38px 26px;
  }
  .cert_tit_box {
    .cert_line {
      width: 100%;
      height: 1px;
      background-color: #303643;
      margin-left: 14px;
    }
  }
  .cert_b_box {
    margin-top: 34px;
  }
  .cert_box {
    .cert_tt {
      font-size: 16px;
      padding-left: 14px;
      border-left: 4px solid #ff8d24;
      font-weight: bold;
    }
  }
  .pass_form {
    width: 560px;
    margin-left: 90px;
    padding: 44px 0 22px 0;
    & >>> .el-form-item__label {
      color: #303643;
      font-weight: bold;
      text-align: right;
    }
    .tradebtn {
      height: 42px;
      background: #303643;
      border-radius: 2px;
      color: #fff;
      border: none;
      width: 100%;
    }
  }

  .inlineInput {
    & >>> .el-input__inner {
      background: #f9fafe;
      border: 1px solid #303643;
      border-radius: 2px;
    }
  }
  .cert_box_l {
    width: 793px;
  }
  .cert_box_r {
  }
  .cert_tt_bg {
    background: #f5f6fa;
    margin-top: 25px;
  }
  .cert_tt_bg_2 {
    background: #f5f6fa;
    margin-top: 25px;
    padding: 77px 150px;
  }
  .upload_btn_box {
    & >>> .el-upload-list--picture-card .el-upload-list__item {
      width: 350px;
      height: 160px;
    }
    & >>> .el-upload-list--picture-card .el-upload-list__item-thumbnail {
    }
    & >>> .el-upload-list__item {
      text-align: center;
    }
    & >>> .el-upload--picture-card {
      line-height: 24px !important;
      width: 350px;
      height: 160px;
    }
  }
  .upload_btn_box.haveImg {
    & >>> .el-upload--picture-card {
      display: none;
    }
  }
  .upload_btn {
    margin-top: 14px;
  }
  .upload_txt {
    color: #ff8d24;
  }
  .upload_tip {
    color: #999;
    font-size: 12px;
  }
  .rzxz_box {
    margin-top: 18px;
    width: 722px;
    padding: 16px 54px 20px 16px;
    background: #fff6ef;
    border: 1px dashed #ff8d24;
    border-radius: 6px;
    .rzxz_tit {
      font-size: 16px;
      color: #ff8d24;
      font-weight: bold;
    }
    .rzxz_txt {
      font-size: 14px;
      margin-top: 14px;
      line-height: 24px;
    }
  }

  .certbtn_box {
    width: 340px;
    margin: 38px auto 0 auto;
  }
  .certbtn {
    height: 42px;
    background: #303643;
    border-radius: 2px;
    color: #fff;
    border: none;
    width: 100%;
  }
  .result_txt{
    text-align: center;
    color: #D52C00;
    font-size: 24px;
    margin: 38px auto 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/certification.vue